module.exports = __webpack_public_path__ + "media/images/leaders-photo-b45ab8f0b7a36f201a5d0563afb5cc7a.jpg";